import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {IconButton, Grid, Dialog, Button, Typography, Icon} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import CloseIcon from '@material-ui/icons/Close';
import RawMarkup from './../../../components/RawMarkup'
import moment from 'moment';

import IconC from './../../../components/_IconC'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function ModalTravelInformation(props) {
  const [open, setOpen] = React.useState(false);
 
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

        const {detailConditions} = props;
        return (
          <div className="modal-condiciones modal-condiciones-pases">
          <Button className="ver-tarifa"  onClick={handleClickOpen} color="secondary">Ver condiciones completas</Button>

          <Dialog maxWidth="sm" onClose={handleClose} aria-labelledby="modal-travel-info" open={open}>
                <DialogTitle id="modal-travel-info" onClose={handleClose}>
                  Condiciones
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                      <Typography variant="h2">{props.title}</Typography>
                      <hr/>
                      {props.conditions.map((condition, i) => {
                         
                        var emptyP = '<p><br></p>'
                        var emptyP2 = '<p><br>'
                        var emptyPx5 = '<p><br><br><br><br><br></p>'
                        var emptyUl = '<ul>\n<li></li>\n</ul>\n'
                        var finalCondition = condition.condition.replaceAll(emptyP,'').replaceAll(emptyPx5,'').replaceAll(emptyP2,'<p>').replaceAll(emptyUl,'');
                        return (
                          <RawMarkup key={i} content={finalCondition} />
                        )
                      }
                          
                      )}
                      {(props.ages && props.page === "tickets") && 
                          <Typography>
                          <span>  
                          <strong>Infoas: </strong>Viajan gratis <strong>sin derecho a asiento y sin ticket</strong> según edades: 
                          Trenes Reino Unido 0-4 años, Alemania y Suiza de 0-5 años, resto de Trenes 0-3 años inclusive.
                          </span>
                        </Typography>
                        }
                        {(props.ages && props.page === "passes") && 
                          <Typography>
                          <br />
                          <span>  	
                          <strong>Infoas: </strong>Viajan gratis <strong> sin derecho a asiento y sin ticket</strong>
                          según edades: Pase Eurail 0-3 años y Pase Suizo de 0-5 años inclusive. 
                          </span>
                        </Typography>
                        }
                    </div>
               </DialogContent>
            <DialogActions>
              <Button className="btn-outlined" variant="outlined"  autoFocus onClick={handleClose} color="primary">
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        ) 
  }
